import {Component} from '@angular/core';
import {AutoScraperBackendService} from "../auto-scraper-backend.service";

@Component({
    selector: 'app-no-hits',
    templateUrl: './no-hits.component.html',
    styleUrls: ['./no-hits.component.css'],
    standalone: false
})
export class NoHitsComponent {
  constructor(public data: AutoScraperBackendService) {}
}
